import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './componant/Homepage';
import Abouthome from './componant/aboutus/Abouthome';
import Header from './componant/Header';
import Contacthome from './componant/contactus/Contacthome';
import Servicehome from './componant/service/Servicehome';
import Servciedetailhome from './componant/servicedetail/Servciedetailhome';
import EducationCRMPage from './componant/softwares/education-crm/index';
import SchoolManagementPage from './componant/softwares/school-management/index';
import RealEstateCRMPage from './componant/softwares/real-estate-crm/index';
import RealEstateListingPage from './componant/softwares/real-estate-listing/index';
import BiometricPayrollPage from './componant/softwares/biometric-payroll/index';

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/abouthome" element={<Abouthome />} />
        <Route path="/contacthome" element={<Contacthome />} />
        <Route path="/servicehome" element={<Servicehome />} />
        <Route path="/servciedetail" element={<Servciedetailhome />} />
        <Route path="/education-crm" element={<EducationCRMPage />} />
        <Route path="/school-management" element={<SchoolManagementPage />} />
        <Route path="/real-estate-crm" element={<RealEstateCRMPage />} />
        <Route path="/real-estate-listing" element={<RealEstateListingPage />} />
        <Route path="/biometric-payroll" element={<BiometricPayrollPage />} />
      </Routes>
    </Router>
  );
};

export default App;
